/** Kế hoạch / mục tiêu: chỉ PDF, tối đa 25 MB */
export const PLAN_MAX_PDF_BYTES = 25 * 1024 * 1024;

export const PLAN_CONTENT_MAX_LENGTH = 250;

/**
 * @param {File | null | undefined} file
 * @returns {{ ok: boolean; message?: string }}
 */
export function validatePlanPdfFile(file) {
  if (!file) return { ok: true };
  const name = (file.name || "").toLowerCase();
  const isPdf = file.type === "application/pdf" || name.endsWith(".pdf");
  if (!isPdf) return { ok: false, message: "Chỉ chấp nhận tệp PDF." };
  if (file.size > PLAN_MAX_PDF_BYTES) {
    return { ok: false, message: "Tệp PDF tối đa 25 MB." };
  }
  return { ok: true };
}
